import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';

export const InputAddExp = ({ textLabel }) => {
  return (
    <div className="input-add-exp">
      <span className="text color-primary">{i18n.t(`${textLabel}`)}</span>
    </div>
  );
};
InputAddExp.propTypes = { textLabel: PropTypes.string.isRequired };
InputAddExp.defaultProps = {};
export default InputAddExp;
